import { Link } from "react-router-dom";
import type { Drama } from "@/types/drama";

interface DramaCardProps {
  drama: Drama;
  className?: string;
}

export default function DramaCard({ drama, className = "" }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      className={`group block cursor-pointer ${className}`}
      aria-label={`查看《${drama.title}》详情`}
    >
      <div className="relative w-full aspect-[5/7] overflow-hidden rounded-lg bg-primary-900">
        <img
          src={drama.cover}
          alt={`${drama.title} 剧集封面`}
          title={`${drama.title} 高清电视剧在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 rounded-md bg-primary-950/80 px-1.5 py-0.5 text-[11px] font-medium text-background-100 backdrop-blur-sm">
          {drama.status}
        </span>
        <span className="absolute top-2 right-2 rounded-md bg-accent-500 px-1.5 py-0.5 text-[11px] font-bold text-primary-950">
          {drama.rating.toFixed(1)}
        </span>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <div className="absolute inset-x-0 bottom-0 translate-y-3 p-3 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-primary-950">
            <i className="ri-play-fill" aria-hidden="true" />
            查看详情
          </span>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 transition-colors group-hover:text-primary-600">
          {drama.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
          {drama.year} · {drama.region} · {drama.genres.join(" / ")}
        </p>
      </div>
    </Link>
  );
}